import { createSubscriptionMachine } from '../../../machines/subscription';

import { useInterpret } from '@xstate/react';

import { useDataAccess } from '../../../hooks';
import { AddCouponEvent } from '../../../../src/models/subscription/subscription';

export const useSubscriptionDetailsService = (subscriptionId: number) => {
  const { dataAccess } = useDataAccess();

  return useInterpret(createSubscriptionMachine, {
    services: {
      getSubscriptionDetails: () => {
        return dataAccess.getSubscriptionDetails(subscriptionId);
      },
      addCoupon: (_ctx, event: AddCouponEvent) => {
        return dataAccess.addCoupon(subscriptionId, event.couponCode);
      },
    },
  });
};
